import React from 'react'
import SidebarTemplate from 'components/templates/SidebarTemplate';
import AttendApplicationApprovalDetail from 'components/organismos/master/attend/AttendApplicationApprovalDetail';

const AttendApplicationApprovalDetailPage = () => {
  return(
    <SidebarTemplate>
      <AttendApplicationApprovalDetail/>
    </SidebarTemplate>
  )
}

export default AttendApplicationApprovalDetailPage